import React from 'react'
import { useLocation, Link } from 'react-router-dom'
const SubHeader = () => {
    const data = [
        {
            "slug": "contact-us",
            "title": "Contact Us",
            "img": "it-consulting.png",
            "link": "contact us",
        },
        {
            "slug": "about-us",
            "title": "About Us",
            "img": "it-consulting.png",
            "link": "about us",
        },
        {
            "slug": "services",
            "title": "Services",
            "img": "it-consulting.png",
            "link": "services",
        },
        {
            "slug": "projects",
            "title": "Projects",
            "img": "it-consulting.png",
            "link": "Projects",
        },
        {
            "slug": "gallery",
            "title": "Gallery",
            "img": "it-consulting.png",
            "link": "gallery",
        }
    ]
    const location = useLocation();
    const slug = location.pathname.replace(/^\/+/, '');
    const headerData = data.find(item => item.slug === slug);
    return (
        <>
            <div className="page-header parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Page Header Box Start */}
                            <div className="page-header-box">
                                <h1 className="text-anime-style-2" data-cursor="-opaque">
                                    {headerData.title}
                                </h1>
                                <nav className="wow fadeInUp">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            {headerData.link}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            {/* Page Header Box End */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default SubHeader
